module.exports = __webpack_public_path__ + "img/text-con-1.79de8c2f.png";